// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 804) return "covid-19.e437c2727b3af2cb0fb8.css";
	// return url for filenames based on template
	return "" + chunkId + "." + {"34":"2f04ed81731ff879124d","355":"8071fe40779dfe4086ab","553":"13572d1ef1052fb2a03c"}[chunkId] + ".css";
};